import { css } from 'linaria';

export const VariantsSelectionGroup = css`
  gap: var(--space-50);
`;
